<template>
  <button class="menu-button"
          @click.stop="overflowButtonClicked"
          tabindex="0"
          :aria-label="ariaLabel || 'תפריט'">
    <icon class="menu-button-icon" icon-name="more_vert" :optical-size="24" :color="menuButtonColor" />
  </button>
</template>

<script>
import Icon from './Icon.vue';

export default {
  name: 'MenuButton',
  components: {
    Icon,
  },
  props: {
    ariaLabel: {
      type: String,
      required: false,
    },
    menuButtonColor: {
      type: String,
      required: false,
    },
  },
  methods: {
    overflowButtonClicked() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
@import "../scss/riseup-colors";

.menu-button {
  // create space around the menu icon to increase click area
  cursor: pointer;
  display: flex;
  border: none;
  background: transparent;
  margin: 0;
  padding: 0;

  .menu-button-icon {
    font-size: 24px;
    margin: 8px;
    color: $riseup_black;
  }
}

</style>
